import {Avatar} from 'antd'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import React from 'react'
import {BsCheckCircleFill, BsPersonCircle} from 'react-icons/bs'
import {IoCloseOutline} from 'react-icons/io5'
import {Link} from 'react-router-dom'

// Badge "đã liên kết tài khoản" DÙNG CHUNG cho mọi field chọn qua UserLookupComponent (fullname của
// Student/Teacher, father_user/mother_user...) - hiện khi field user đã có giá trị, khác hẳn ô nhập
// text bình thường (bạn báo "nếu đúng thì phải có màu khác, có link đến user chứ không phải text") -
// trước đây chọn xong qua UserLookupComponent không có phản hồi UI nào rõ ràng, dễ tưởng chưa chọn
// được dù thật ra ĐÃ set vào form. `user` truyền vào PHẢI đã đúng shape _type:'user' (owner từ lookup
// response, KHÔNG phải nguyên object lookup thô _type:'lookup') để getTitle/getAvatar/getLinkToDetail
// hoạt động đúng - xem chỗ gọi `handleApply` ở từng form (StudentForm.js/TeacherForm.js...).
// 1 KHỐI liền mạch (1 viền/nền duy nhất bọc cả avatar+tên VÀ nút gỡ liên kết) - trước đây nút gỡ
// (X) là 1 button đứng NGOÀI, tự có viền/nền riêng, đặt cạnh box xanh qua gap-2 -> nhìn như 2 mảnh
// rời rạc thay vì 1 "chip đã liên kết" (bạn báo "nút xóa để tách rời ra, chưa đẹp, chưa hiện đại").
// Giờ Link (điều hướng) và nút X (gỡ liên kết) là 2 con NẰM CHUNG 1 div viền xanh - X không còn
// viền/nền riêng, chỉ đổi màu khi hover, ngăn cách bằng 1 đường kẻ dọc mờ - đúng pattern "chip có nút
// đóng" quen thuộc (antd Tag closable) thay vì 2 button tách biệt.
export const LinkedAccountBadge = ({user, onUnlink, t}) => {
    if (!user) return null
    return (
        <div className="flex items-center gap-2 pl-2.5 pr-1.5 py-1.5 bg-green-50 border border-green-300 rounded-lg">
            <Link
                to={getLinkToDetail(user)}
                target="_blank"
                className="flex-1 min-w-0 flex items-center gap-2 no-underline group">
                <Avatar
                    size={26}
                    src={getAvatar(user)}
                    icon={<BsPersonCircle size={14} className="text-color-500"/>}
                    className="flex-shrink-0 background-200"
                />
                <div className="flex flex-col min-w-0 flex-1">
                    <span className="font-bold text-xs text-green-700 truncate group-hover:underline">{getTitle(user)}</span>
                    {user?.email && <span className="text-2xs text-green-600 truncate">{user.email}</span>}
                </div>
                <BsCheckCircleFill size={13} className="text-green-500 flex-shrink-0"/>
            </Link>
            <span className="w-px self-stretch bg-green-200 flex-shrink-0"/>
            <button
                type="button"
                onClick={onUnlink}
                title={t('remove account link')}
                style={{width: 28, height: 28}}
                className="flex-shrink-0 flex flex-center rounded-md text-green-600 hover:bg-red-100 hover:text-red-500 cursor-pointer transition-colors">
                <IoCloseOutline size={16}/>
            </button>
        </div>
    )
}

export default LinkedAccountBadge
